/** Map Contentful asset URL to parseEntry-style string. */
function mapAssetUrl(asset) {
  if (!asset?.url) return null

  const raw = asset.url.trim()
  if (!raw) return null
  if (/^https?:\/\//i.test(raw)) return raw
  if (raw.startsWith('//')) return `https:${raw}`

  return `https://${raw.replace(/^\/+/, '')}`
}

function mapAssetFile(asset) {
  const url = mapAssetUrl(asset)
  if (!url) return null

  return {
    url,
    title: asset.title ?? '',
    width: asset.width,
    height: asset.height,
    contentType: asset.contentType,
  }
}

/** Map GraphQL TrustMarker item → REST parseEntry flat shape. */
export function mapTrustMarkerGql(item) {
  if (!item) return null

  const imageAsset = mapAssetFile(item.image)
  const logoAsset = mapAssetFile(item.logo)

  return {
    key: item.sys?.id ?? null,
    id: item.id,
    link: item.link,
    alt: item.alt ?? '',
    rating: item.rating,
    totalReview: item.totalReview,
    letterGrade: item.letterGrade,
    lastTimeVerified: item.lastTimeVerified,
    image: imageAsset?.url ?? null,
    imageAsset,
    logo: logoAsset?.url ?? null,
    logoAsset,
    contentType: 'trustMarker',
  }
}

/** Map GraphQL trustMarkersCombination item → REST parseEntry shape. */
export function mapTrustMarkersCombinationGql(item) {
  if (!item) return null

  const trustMarker = (item.trustMarkerCollection?.items ?? [])
    .map(mapTrustMarkerGql)
    .filter(Boolean)

  return {
    key: item.sys?.id ?? null,
    id: item.id,
    trustMarker,
    contentType: 'trustMarkersCombination',
  }
}

/**
 * Map raw TrustBundle GraphQL response.
 * @returns {{ combinations: Array, markers: Array, reviews: Record<string, unknown> }}
 */
export function mapTrustBundleGql(data) {
  const combinations = (data?.combinations?.items ?? [])
    .map(mapTrustMarkersCombinationGql)
    .filter(Boolean)

  const markers = (data?.markers?.items ?? [])
    .map(mapTrustMarkerGql)
    .filter(Boolean)

  const reviewsEntry = data?.reviews?.items?.[0]
  const reviews =
    reviewsEntry?.values && typeof reviewsEntry.values === 'object'
      ? reviewsEntry.values
      : {}

  return { combinations, markers, reviews }
}
